<div>
    <div class="d-flex justify-content-end mb-3">
        <button type="button" class="em-btn em-btn--primary" (click)="openNuevoProcedimiento()">
            <mat-icon>add</mat-icon> {{ 'PROCEDIMIENTOS.NEW' | translate }}
        </button>
    </div>

    <p *ngIf="esGmu" class="text-muted mb-3">
        {{ 'PROCEDIMIENTOS.GMU_HINT' | translate }}
    </p>

    <div class="listado__stats">
        <div class="listado__stat">
            <div class="listado__stat-value">{{ totalProcedimientos }}</div>
            <div class="listado__stat-label">{{ 'COMMON.TOTAL' | translate }}</div>
        </div>
        <div class="listado__stat">
            <div class="listado__stat-value is-success">{{ procedimientosActivos }}</div>
            <div class="listado__stat-label">{{ 'COMMON.ACTIVE' | translate }}</div>
        </div>
        <div class="listado__stat">
            <div class="listado__stat-value is-muted">{{ procedimientosInactivos }}</div>
            <div class="listado__stat-label">{{ 'COMMON.INACTIVE' | translate }}</div>
        </div>
    </div>

    <div class="listado listado--cards-accent">
        <table mat-table [dataSource]="dataSource" matSort class="table align-middle mb-0 bg-white">
            <ng-container matColumnDef="departamento.nombre" class="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by departamento.nombre" class="header">{{ 'PROCEDIMIENTOS.COL_DEPT' | translate }}</th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'PROCEDIMIENTOS.COL_DEPT' | translate">
                    {{ element.departamento.nombre }}
                </td>
            </ng-container>

            <ng-container matColumnDef="nombre">
                <th class="asuntoNombre" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by nombre" class="header">{{ 'PROCEDIMIENTOS.COL_NAME' | translate }}</th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'PROCEDIMIENTOS.COL_NAME' | translate" data-role="title">
                    {{ element.nombre }}
                </td>
            </ng-container>

            <ng-container matColumnDef="visible">
                <th mat-header-cell *matHeaderCellDef class="header">{{ 'PROCEDIMIENTOS.COL_STATUS' | translate }}</th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'PROCEDIMIENTOS.COL_STATUS' | translate" data-role="status">
                    <button class="asuntoActivo" *ngIf="element.visible">&nbsp;{{ 'COMMON.ACTIVE' | translate }}&nbsp;</button>
                    <button class="asuntoInactivo" *ngIf="!element.visible">{{ 'COMMON.INACTIVE' | translate }}</button>
                </td>
            </ng-container>

            <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef class="header em-th-actions">{{ 'COMMON.ACTIONS' | translate }}</th>
                <td mat-cell *matCellDef="let element" data-role="actions" class="em-td-actions">
                    <div class="em-actions-wrap">
                        <button type="button" class="em-icon-btn" [matTooltip]="'PROCEDIMIENTOS.TOOLTIP_EDIT' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" (click)="openEditarProcedimiento(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button type="button" class="em-icon-btn" [matTooltip]="'PROCEDIMIENTOS.TOOLTIP_COPY' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" (click)="openCopiarProcedimiento(element)">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                        <button type="button" class="em-icon-btn em-icon-btn--danger" [matTooltip]="'PROCEDIMIENTOS.TOOLTIP_DELETE' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" (click)="openDeleteDialog(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5" showFirstLastButtons style="padding: 15px;">
        </mat-paginator>

        <div class="load-more-row" *ngIf="paginator?.hasNextPage()">
            <button type="button" class="load-more-btn" (click)="cargarMas()">{{ 'COMMON.LOAD_MORE' | translate }}</button>
        </div>
    </div>
</div>
